import {
  DownloadSimple,
  FilePdf,
  Paperclip,
  VideoCamera,
} from "@phosphor-icons/react"
import { Image } from "@vesatogo/grass-core"
import { getExtension } from "@vesatogo/utils"
import { Link } from "react-router-dom"

export const AttachmentsCard = ({ attachments = [] }: { attachments: any }) => {
  return (
    <div className="bg-white border-1 border-gray-300 rounded-xl p-4 flex flex-col gap-4 max-h-[400px] overflow-y-auto bg-gray-200">
      <header className="flex items-center gap-2 pb-2 border-b border-gray-50">
        <Paperclip size={18} className="text-gray-700" />
        <span className="font-500 text-gray-800">Attachments</span>
      </header>

      <div className="flex flex-col gap-4">
        {attachments?.map(file => (
          <div key={file?.id} className="flex flex-col gap-2 ">
            <div className="flex items-center justify-between p-2 rounded-lg  bg-white rounded-lg border-1 border-gray-300">
              <div className="flex items-center gap-3">
                {(() => {
                  const url = file?.media?.url || ""
                  const extension = getExtension(url)?.toLowerCase()
                  const isPdf = extension === "pdf"
                  const isVideo = ["mp4", "webm", "mov", "avi", "mkv"].includes(
                    extension || ""
                  )
                  const isImage =
                    file?.media?.kind === "image/png" ||
                    ["jpg", "jpeg", "png", "webp", "gif"].includes(
                      extension || ""
                    )

                  if (isImage) {
                    return (
                      <div className="p-1 bg-white rounded border border-gray-300">
                        <Image
                          src={url}
                          className="text-purple-500 h-10 w-10"
                        />
                      </div>
                    )
                  } else if (isVideo) {
                    return (
                      <div className="p-2 bg-white rounded border border-gray-100">
                        <VideoCamera size={24} className="text-blue-500" />
                      </div>
                    )
                  } else {
                    return (
                      <div className="p-2 bg-white rounded border border-gray-100">
                        <FilePdf size={24} className="text-red-500" />
                      </div>
                    )
                  }
                })()}
                <div className="flex flex-col">
                  <span className="text-xs font-600 text-gray-800 truncate max-w-[150px]">
                    {file?.media?.url}
                  </span>
                </div>
              </div>
              <button className="text-gray-500 hover:text-gray-800">
                <Link to={file?.media?.url} target="_blank">
                  <DownloadSimple size={20} />
                </Link>
              </button>
            </div>
            {file.send_whatsapp && (
              <p className="text-xs text-blue-400 italic px-1">
                {"This file has been shared with buyers on WhatsApp."}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
